/* Gretchen Masonry Heaters — kit picker
   Three questions → one recommendation from the 13 home kits.
   Loads products.json on init, re-scores live as the user answers. */

(function () {
  "use strict";

  const form = document.getElementById("kit-picker-form");
  const result = document.getElementById("picker-result");
  const volOut = document.getElementById("p-volume-out");
  const volInput = document.getElementById("p-volume");
  if (!form || !result) return;

  const CAD = new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: "CAD",
    maximumFractionDigits: 0,
  });

  let products = null;
  let debounce = 0;

  // --- Read catalog from Liquid-rendered <script id="kits-data"> -----
  const dataEl = document.getElementById("kits-data");
  if (dataEl) {
    try {
      const raw = JSON.parse(dataEl.textContent);
      // Already filtered to home-heaters collection in Liquid; defensive filter remains.
      products = raw.filter((p) => p.kind !== "sauna");
      scheduleUpdate();
    } catch (e) {
      console.warn("Picker: kits-data parse failed", e);
    }
  }

  // --- Scoring logic --------------------------------------------------
  function score(kit, answers) {
    const cap = kit.heating_m3 || 0;
    const ratio = cap / answers.volume;

    let capScore;
    if (ratio >= 1.0 && ratio <= 1.5)        capScore = 100;
    else if (ratio >= 0.85 && ratio < 1.0)   capScore = 60;
    else if (ratio > 1.5 && ratio <= 2.2)    capScore = 65;
    else if (ratio < 0.85)                   capScore = -60;
    else                                     capScore = 10;

    let climateBonus = 0;
    if (answers.climate === "severe") climateBonus = cap >= 500 ? 25 : -10;
    if (answers.climate === "mild")   climateBonus = cap <= 400 ? 15 : -5;
    if (answers.climate === "moderate") climateBonus = cap >= 300 && cap <= 650 ? 10 : 0;

    let chimneyBonus = 0;
    if (answers.chimney === "to-build" && cap < 400) chimneyBonus = 5;

    const priceBonus = -((kit.price_cad || 0) / 1000) * 0.5;

    return capScore + climateBonus + chimneyBonus + priceBonus;
  }

  function pickBest(answers) {
    let best = null;
    let bestScore = -Infinity;
    for (const p of products) {
      const s = score(p, answers);
      if (s > bestScore) { best = p; bestScore = s; }
    }
    return best;
  }

  // --- Reasons — three lines, ~3 words each. Card overlay has no room. ---
  function reasons(kit, answers) {
    const out = [];
    const ratio = (kit.heating_m3 || 0) / answers.volume;
    const cap = kit.heating_m3 || 0;

    // 1 — capacity
    if (ratio >= 1.0 && ratio <= 1.5)      out.push(cap + " m³ match");
    else if (ratio > 1.5)                  out.push(cap + " m³ headroom");
    else                                   out.push(cap + " m³ close");

    // 2 — climate
    if (answers.climate === "severe")      out.push("Winter-grade mass");
    else if (answers.climate === "mild")   out.push("Right-sized for mild");
    else                                   out.push("Zone 6 tuned");

    // 3 — chimney
    if (answers.chimney === "to-build")                 out.push("Chimney specs included");
    else if (answers.chimney === "existing-insulated")  out.push("Fits insulated flues");
    else                                                out.push("Pairs with masonry");

    return out.slice(0, 3);
  }

  // --- Render result --------------------------------------------------
  function render(kit, answers) {
    const img = kit.image || "";
    const alt = kit.image_alt || kit.title;
    const url = kit.url || "#";
    const priceNum = parseFloat(String(kit.price_cad).replace(/[^0-9.]/g, "")) || 0;

    result.dataset.state = "filled";
    result.innerHTML = `
      <article class="picker-card" aria-labelledby="rec-title">
        <div class="rec-media">
          <img src="${img}" alt="${alt}" loading="lazy" width="600" height="800" />
        </div>
        <div class="rec-body">
          <p class="rec-eyebrow">Our pick for you</p>
          <h3 id="rec-title" class="rec-title">${kit.title}</h3>
          <p class="rec-price">${CAD.format(priceNum)}<small style="font-size: var(--fs-micro); opacity: 0.6; font-weight: 500; letter-spacing: var(--tr-caps); text-transform: uppercase; margin-left: var(--s-xs);">CAD</small></p>
          <ul class="rec-reasons">
            ${reasons(kit, answers).map((r) => `<li>${r}</li>`).join("")}
          </ul>
          <div class="rec-actions">
            <a href="${url}" class="btn btn-primary">View this kit</a>
          </div>
        </div>
      </article>
    `;
  }

  // --- Read form state, pick, render ---------------------------------
  function update() {
    if (!products) return;
    const data = new FormData(form);
    const answers = {
      volume: parseInt(data.get("volume"), 10) || 350,
      chimney: data.get("chimney") || "existing-masonry",
      climate: data.get("climate") || "moderate",
    };
    const best = pickBest(answers);
    if (best) render(best, answers);
  }
  function scheduleUpdate() {
    clearTimeout(debounce);
    debounce = setTimeout(update, 120);
  }

  // --- Wire up events -------------------------------------------------
  volInput?.addEventListener("input", (e) => {
    if (volOut) volOut.textContent = e.target.value;
    scheduleUpdate();
  });
  form.addEventListener("change", scheduleUpdate);
  form.addEventListener("input", (e) => {
    if (e.target.type === "radio") scheduleUpdate();
  });
})();
